import React, {useState} from "react";
import useIsMounted from "../../../../hooks/use-is-mounted";
import IconButton from "../../../base/button/icon_button";
import {Edit} from "@mui/icons-material";
import {SvgIcon} from "@mui/material";
import {ReactComponent as RemoveIcon} from "../../../../../assets/images/remove.svg";
import {ReactComponent as TimeIcon} from "../../../../../assets/images/notifications/time.svg";
import UpsertProductNoteDialog from "../../../dialogs/upsert-product-note";
import DateUtils from "../../../../../core/services/date-utils";

const ProductNoteCard = ({note, update, remove}) => {
    const [removing, setRemoving] = useState(false);
    const [editDialog, setEditDialog] = useState(false);
    const isMounted = useIsMounted();

    /**
     * Removes the current note by calling its respective callback.
     * @return {Promise<void>}
     */
    const removeNote = async () => {
        setRemoving(true);
        await remove(note);
        if (!isMounted()) return;
        setRemoving(false);
    }

    /**
     * Gets users confirmation before removing the current note entirely.
     */
    const getRemoveConfirmation = () => {
        window.partner?.openConfirmationDialog(
            <div className={'p-3'}>
                <p className={'text-sm text-color-2'}>
                    Are you sure that you want to remove this note?
                </p>
            </div>,
            {
                maxWidth: 'sm'
            },
            (v) => v && removeNote(),
        );
    }

    return (
        <>
            <div className={'product-note-card'}>
                <div className={'d-flex w-100 justify-content-between mb-3'}>
                    <p className={'title'}>
                        {note?.title ?? ''}
                    </p>
                    <div className={'d-flex align-items-center justify-content-end'}>
                        <IconButton
                            disabled={removing}
                            className={"mx-1"}
                            color={'paper.secondary'}
                            onPressed={() => setEditDialog(true)}
                        >
                            <Edit className={"icon normal"}/>
                        </IconButton>
                        <IconButton
                            onPressed={getRemoveConfirmation}
                            disabled={removing}
                            color={'paper.error'}
                        >
                            <SvgIcon component={RemoveIcon} className='icon normal'/>
                        </IconButton>
                    </div>
                </div>
                <div className={'w-100'}>
                    <div
                        className={'description'}
                        dangerouslySetInnerHTML={{__html: note?.msg ?? ""}}
                    />
                </div>
                <div className={'d-flex justify-content-between align-items-center w-100'}>
                    <div className={'flex-grow-1'}>
                        <p className={'date'}>
                            <TimeIcon/>
                            {
                                (note?.submitDateTime ?? note?.submittedDateTime)
                                    ? DateUtils.serverToLocal(note?.submitDateTime ?? note?.submittedDateTime).format(DateUtils.dateTimeFormat)
                                    : ''
                            }
                        </p>
                    </div>
                </div>
            </div>
            <UpsertProductNoteDialog
                note={note}
                isForClient={note?.isForClient}
                open={editDialog}
                close={() => setEditDialog(false)}
                submit={update}
            />
        </>
    );
}


export default ProductNoteCard;
